import { supabase } from '../lib/supabase';

export type Persona = 'individual' | 'coach' | 'organizer';

/**
 * Reads and writes `profiles.persona`, the answer picked at /welcome.
 *
 * Direct client UPDATE on `profiles` is revoked (sc-276/B2), so writes go
 * through the `set_persona` SECURITY DEFINER RPC, which derives the target
 * row from auth.uid() and validates the value server-side.
 */
export const personaService = {
  async getPersona(userId: string): Promise<Persona | null> {
    const { data, error } = await supabase
      .from('profiles')
      .select('persona')
      .eq('id', userId)
      .single();

    if (error) {
      console.error('[personaService] Error fetching persona:', error);
      return null;
    }
    return (data?.persona as Persona | null) ?? null;
  },

  async setPersona(persona: Persona): Promise<void> {
    const { error } = await supabase.rpc('set_persona', { p_persona: persona });
    if (error) {
      console.error('[personaService] Error setting persona:', error);
      throw error;
    }
  },
};
